/**
 * Constants for Status screen settings and customization.
 */

/**
 * Height of the stream waveform component in pixels for list view.
 */
export const STREAM_HEIGHT = 140;

/**
 * Height of the stream waveform component in pixels for grid (compact) view.
 */
export const STREAM_HEIGHT_COMPACT = 110;

/**
 * Preview time range in minutes for compact mode.
 */
export const PREVIEW_MINUTES_COMPACT = 3;

/**
 * Preview time range in minutes for normal mode.
 */
export const PREVIEW_MINUTES_NORMAL = 6;

/**
 * Default time range in minutes for fetching segments.
 */
export const DEFAULT_TIME_RANGE_MINUTES = 6;

/**
 * Default time range in milliseconds for fetching segments.
 */
export const DEFAULT_TIME_RANGE_MS = DEFAULT_TIME_RANGE_MINUTES * 60 * 1000;

/**
 * Shared refetch interval for status and segments queries so the
 * online/offline badge and waveform stay in sync.
 */
export const STATUS_SCREEN_REFETCH_INTERVAL_MS = 15 * 1000;

/**
 * Refetch interval in milliseconds for segments query.
 */
export const SEGMENTS_REFETCH_INTERVAL_MS = STATUS_SCREEN_REFETCH_INTERVAL_MS;

/**
 * Refetch interval in milliseconds for status query.
 */
export const STATUS_REFETCH_INTERVAL_MS = STATUS_SCREEN_REFETCH_INTERVAL_MS;

/**
 * Preload margin in pixels before status card enters viewport.
 */
export const STATUS_FETCH_SEGMENTS_MARGIN_PX = '200px';

/**
 * Root margin in pixels for intersection observer in status query.
 */
export const STATUS_QUERY_ROOT_MARGIN_PX = '200px';

/**
 * Thumbnail offset in milliseconds before segment end to avoid edge.
 */
export const THUMBNAIL_LIVE_OFFSET_MS = 2000;

/**
 * Thumbnail height in pixels for compact mode.
 */
export const THUMBNAIL_HEIGHT_COMPACT = 80;

/**
 * Thumbnail height in pixels for default mode.
 */
export const THUMBNAIL_HEIGHT_DEFAULT = 115;

/**
 * Thumbnail preview container width in pixels for normal mode.
 * Includes thumbnail width (205px) plus padding (16px * 2).
 */
export const THUMB_PREVIEW_WIDTH = 205 + 16 * 2;

/**
 * Thumbnail preview container width in pixels for compact mode.
 * Includes thumbnail width (150px) plus padding (8px * 2).
 */
export const THUMB_PREVIEW_WIDTH_COMPACT = 150 + 8 * 2;
